import TitleDeedIcon from './TitleDeedIcon'

export default TitleDeedIcon
